import SeoLandingPage from "@/components/SeoLandingPage";
import heroImage from "@/assets/basement-demolition.jpg";

const BasementDemolition = () => (
  <SeoLandingPage
    slug="basement-demolition-wisconsin"
    metaTitle="Basement Demolition & Tear-Out | Northeast Wisconsin"
    metaDescription="Basement demolition in Green Bay, De Pere, Appleton, and Northeast Wisconsin. Remove finished walls, ceilings, flooring, built-ins, and debris for renovation."
    h1="Basement Demolition in Northeast Wisconsin"
    heroImage={heroImage}
    heroIntro="Clear outdated finishes and prepare your basement for a safer, better-planned renovation with selective removal and complete debris hauling."
    serviceName="Basement Demolition"
    bullets={[
      "Paneling, drywall, non-structural framing, and built-in removal.",
      "Suspended ceiling, ceiling tile, insulation, and finish removal.",
      "Carpet, laminate, vinyl, tile, and underlayment removal.",
      "Bar, cabinet, shelving, and outdated finished-area tear-out.",
      "Protection around stairs, mechanical equipment, utilities, and foundation surfaces.",
      "Debris hauling and broom-clean renovation handoff.",
    ]}
    whyUs={[
      "Basement-specific planning for stairs, low clearances, utilities, and limited exit routes.",
      "Selective work keeps mechanical systems and approved structural elements protected.",
      "The same crew completes removal, loading, and hauling.",
      "Photo-based estimates are available for clearly visible basement projects.",
    ]}
    processSteps={[
      { title: "Show the full space", detail: "Send photos of every finished area, the stairs, exterior access, utilities, and materials to be removed." },
      { title: "Review conditions", detail: "We identify utility conflicts, suspected hazardous materials, moisture concerns, and structural boundaries before work." },
      { title: "Complete selective tear-out", detail: "Finishes are removed in an organized sequence while protected systems remain in place." },
      { title: "Remove debris", detail: "We carry out, load, haul, and sweep the approved work area for the next phase." },
    ]}
    faqs={[
      { q: "What can be removed during basement demolition?", a: "Common scopes include finished walls, paneling, suspended ceilings, flooring, non-structural framing, cabinets, bars, and built-ins. Structural and utility work requires separate review." },
      { q: "How much does basement demolition cost?", a: "Pricing depends on finished square footage, material layers, stair access, disposal volume, utility conflicts, and the final condition requested. Upload photos for a tailored estimate." },
      { q: "Do you remove basement insulation?", a: "Yes, standard insulation can be included. Suspected mold, asbestos-containing material, or other hazards require testing and an appropriate handling plan before disturbance." },
      { q: "Can you remove basement walls?", a: "We remove approved non-load-bearing partitions. Structural walls, posts, beams, and foundation elements are not removed without engineering and required permits." },
      { q: "Do you haul everything out through the house?", a: "We choose the safest practical debris route and protect it. Exterior basement access is helpful, but many projects can be completed through protected interior stairs." },
    ]}
    ctaHeadline="Planning a basement renovation?"
  />
);

export default BasementDemolition;
